import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@shopify/polaris';
import { HomeIcon, ProfileIcon, OrderIcon, PersonIcon, ListBulletedIcon, ExportIcon, DatabaseAddIcon, SettingsIcon } from '@shopify/polaris-icons';
import Logo from '../assets/img/logo.png';
import { jwtDecode } from "jwt-decode";
import { useNavigate } from 'react-router-dom';

const Navbar = ({ toggleMenu }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  if (!token) {
    navigate("/login", { replace: true });
    return;
  }
  const decoded = jwtDecode(token);
  const userRole = decoded.role;
  return (
    <nav className="navbar_left">
      <div className="navbar-logo">
        <NavLink to="/">
          <img src={Logo} alt="Company Logo" />
        </NavLink>
      </div>
      <ul className="navbar-links">
        <li>
          <NavLink
            to="/dashboard"
            end
            className={({ isActive }) => isActive ? 'active-link' : undefined}
            onClick={toggleMenu}
          >
            <Icon source={HomeIcon} tone="base" /> Home
          </NavLink>
        </li>
        {userRole === "admin" && (
          <li>
            <NavLink
              to="sales-reps"
              className={({ isActive }) => isActive ? 'active-link' : undefined}
              onClick={toggleMenu}
            >
              <Icon source={ListBulletedIcon} tone="base" /> Sales Reps
            </NavLink>
          </li>
        )}
        <li>
          <NavLink
            to="orders"
            className={({ isActive }) => isActive ? 'active-link' : undefined}
            onClick={toggleMenu}
          >
            <Icon source={OrderIcon} tone="base" /> My Orders
          </NavLink>
        </li>
        <li>
          <NavLink
            to="customers"
            className={({ isActive }) => isActive ? 'active-link' : undefined}
            onClick={toggleMenu}
          >
            <Icon source={PersonIcon} tone="base" /> Customers
          </NavLink>
        </li>
        {userRole === "admin" && (
          <li>
            <NavLink
              to="profile"
              className={({ isActive }) => isActive ? 'active-link' : undefined}
              onClick={toggleMenu}
            >
              <Icon source={ProfileIcon} tone="base" /> Profile
            </NavLink>
          </li>
        )}
        {userRole === "admin" && (
          <li>
            <NavLink
              to="exportcsv"
              className={({ isActive }) => isActive ? 'active-link' : undefined}
              onClick={toggleMenu}
            >
              <Icon source={ExportIcon} tone="base" /> Export CSV
            </NavLink>
          </li>
        )}
        {userRole === "admin" && (
          <><li>
            <NavLink
              to="addFabric"
              className={({ isActive }) => isActive ? 'active-link' : undefined}
              onClick={toggleMenu}
            >
              <Icon source={DatabaseAddIcon} tone="base" />Library
            </NavLink>
          </li>
            {/* <li>
              <NavLink
                to="settings"
                className={({ isActive }) => isActive ? 'active-link' : undefined}
                onClick={toggleMenu}
              >
                <Icon source={SettingsIcon} tone="base" />Settings
              </NavLink>
          </li> */}
          </>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;
